import React from 'react';
import {Box} from '@mui/material';
import {Outlet} from 'react-router';
import SourcesFileViewerModal from '../products/reportEditorPage/leftPanel/components/SourcesFileViewerModal';
import useCollectionMaterialUploadQueue from './components/useCollectionMaterialUploadQueue';

/**
 * Minimal layout wrapper for roles that access Collection pages via deep links (analyst,
 * reviewer, briefer, real_user, …). Mounts the upload queue processor so file uploads
 * function identically to CollectionLayout. Per-task progress is shown inline in the
 * Collected Materials table — no separate queue panel.
 */
export default function CollectionQueueLayout() {
    useCollectionMaterialUploadQueue();

    return (
        <Box sx={{display: 'flex', flexDirection: 'column', height: '100%', minHeight: 0}}>
            <Box sx={{flex: 1, minHeight: 0, overflow: 'auto'}}>
                <Outlet/>
            </Box>
            <SourcesFileViewerModal/>
        </Box>
    );
}
